import React, { useState } from 'react'

import { Box, ChevronRightIcon, Collapsible, Flex } from '@hivewatch/dark'

import { IncidentNoteMediaIProps } from '../../../shared/types/feedTypes'
import { FileDescription } from './FileDescription'
import { MediaGrid } from './MediaGrid'

export const IncidentNoteMedia = ({ files }: IncidentNoteMediaIProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const toggleDropDown = () => setIsOpen(!isOpen)

  return (
    <Flex direction='column' px={3} py={2} transition='all 0.2s'>
      <Flex mr='10px'>
        <FileDescription files={files} />
        {files.length > 0 && (
          <Box
            cursor='pointer'
            onClick={toggleDropDown}
            transform={isOpen ? 'rotate(90deg)' : 'rotate(0deg)'}
            transition='0.2s'
          >
            <ChevronRightIcon height={20} width={20} />
          </Box>
        )}
      </Flex>
      {files.length > 0 && (
        <Collapsible.Root open={isOpen}>
          <Collapsible.Content>
            <Flex mt='10px' padding='5px'>
              <MediaGrid files={files} />
            </Flex>
          </Collapsible.Content>
        </Collapsible.Root>
      )}
    </Flex>
  )
}
